import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import * as TYPES from '../constants/actionTypes'
import * as actions from './actions'
import { initialState } from './initialState'

export const DISTANCE_LEARNING_TIMETABLE = 'DistanceLearningTimetable'

const timetableSlice = createSlice({
  name: DISTANCE_LEARNING_TIMETABLE,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actions.distanceLearningTimetable.pending, state => {
        state[TYPES.DISTANCE_LEARNING_TIMETABLE].loading = true
      })
      .addCase(actions.distanceLearningTimetable.rejected, (state, action) => {
        state[TYPES.DISTANCE_LEARNING_TIMETABLE].loading = false
        state[TYPES.DISTANCE_LEARNING_TIMETABLE].error = action.payload as AxiosError
      })
      .addCase(actions.distanceLearningTimetable.fulfilled, (state, action) => {
        state[TYPES.DISTANCE_LEARNING_TIMETABLE].loading = false
        state[TYPES.DISTANCE_LEARNING_TIMETABLE].error = null
        state[TYPES.DISTANCE_LEARNING_TIMETABLE].data = action.payload
      })

    // builder
    //   .addCase(actions.timetableUpdated.pending, state => {
    //     state[TYPES.TIMETABLE_UPDATED].loading = true
    //   })
    //   .addCase(actions.timetableUpdated.rejected, (state, action) => {
    //     state[TYPES.TIMETABLE_UPDATED].loading = false
    //     state[TYPES.TIMETABLE_UPDATED].error = action.payload as AxiosError
    //   })
    //   .addCase(actions.timetableUpdated.fulfilled, (state, action) => {
    //     state[TYPES.TIMETABLE_UPDATED].loading = false
    //     state[TYPES.TIMETABLE_UPDATED].error = null
    //     state[TYPES.TIMETABLE_UPDATED].data = action.payload
    //   })

    builder
      .addCase(actions.distanceLearningTimetableAll.pending, state => {
        state[TYPES.DISTANCE_LEARNING_TIMETABLE_ALL].loading = true
      })
      .addCase(actions.distanceLearningTimetableAll.rejected, (state, action) => {
        state[TYPES.DISTANCE_LEARNING_TIMETABLE_ALL].loading = false
        state[TYPES.DISTANCE_LEARNING_TIMETABLE_ALL].error = action.payload as AxiosError
      })
      .addCase(actions.distanceLearningTimetableAll.fulfilled, (state, action) => {
        state[TYPES.DISTANCE_LEARNING_TIMETABLE_ALL].loading = false
        state[TYPES.DISTANCE_LEARNING_TIMETABLE_ALL].error = null
        state[TYPES.DISTANCE_LEARNING_TIMETABLE_ALL].data = action.payload
      })

    // builder
    //   .addCase(actions.timetableGenerate.pending, state => {
    //     state[TYPES.TIMETABLE_GENERATE].loading = true
    //   })
    //   .addCase(actions.timetableGenerate.rejected, (state, action) => {
    //     state[TYPES.TIMETABLE_GENERATE].loading = false
    //     state[TYPES.TIMETABLE_GENERATE].error = action.payload as AxiosError
    //   })
    //   .addCase(actions.timetableGenerate.fulfilled, (state, action) => {
    //     state[TYPES.TIMETABLE_GENERATE].loading = false
    //     state[TYPES.TIMETABLE_GENERATE].error = null
    //     state[TYPES.TIMETABLE_GENERATE].data = action.payload
    //   })
  },
})

export const { reducer: distanceLearningTimetableReducer } = timetableSlice
